/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-extraneous-dependencies */

import React, { memo } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { TAB_ACTION, TAB_TEXT } from '../../constants';
import { makeCursorPointer } from '../../helper';
import utils from '../../../../lib/utils';

export const NavTabs = memo(({ selectedTab, handleTabChange, user }) => {
  const canSeeWorkNotes =
    user?.role === 'superAdmin' || user?.role === 'companyGroupAdmin';

  return (
    <>
      <Nav tabs>
        {canSeeWorkNotes && (
        <NavItem style={makeCursorPointer}>
          <NavLink
            onClick={handleTabChange(TAB_ACTION.WORK_NOTES)}
            className={classnames({ active: selectedTab.includes(TAB_ACTION.WORK_NOTES) })}
          >
            {TAB_TEXT.WORK_NOTES}
          </NavLink>
        </NavItem>
        )}
        {
          utils.filterCustomer(user?.role) ? (
            <>
              <NavItem style={makeCursorPointer}>
                <NavLink
                  onClick={handleTabChange(TAB_ACTION.DEVICE_ACTIVITY)}
                  className={classnames({ active: selectedTab.includes(TAB_ACTION.DEVICE_ACTIVITY) })}
                >
                  {TAB_TEXT.DEVICE_ACTIVITY}
                </NavLink>
              </NavItem>
              <NavItem style={makeCursorPointer}>
                <NavLink
                  onClick={handleTabChange(TAB_ACTION.RECORDINGS)}
                  className={classnames({ active: selectedTab.includes(TAB_ACTION.RECORDINGS) })}
                >
                  {TAB_TEXT.RECORDINGS}
                </NavLink>
              </NavItem>
              <NavItem style={makeCursorPointer}>
                <NavLink
                  onClick={handleTabChange(TAB_ACTION.QC)}
                  className={classnames({ active: selectedTab.includes(TAB_ACTION.QC) })}
                >
                  {TAB_TEXT.QC}
                </NavLink>
              </NavItem>
            </>) : null
        }

      </Nav>
    </>
  );
});
